import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { SuiModule } from 'ng2-semantic-ui';
import { MyDatePickerModule } from 'mydatepicker';

import { AppComponent } from './app.component';
import { MapComponent } from './components/map/map.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { BodyPartsComponent } from './components/body-parts/body-parts.component';
import { BookVisitComponent } from './components/book-visit/book-visit.component';
import { BookingSuccessComponent } from './components/booking-success/booking-success.component';
import { LoginComponent } from './components/login/login.component';
import { BookingsComponent } from './components/bookings/bookings.component';
import { ProfileComponent } from './components/profile/profile.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SignupComponent } from './components/signup/signup.component';
import { customValidatorDirective } from './components/signup/customValidator';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { InfoMessagesComponent } from './components/info-messages/info-messages.component';
import { OfferBookingFisiqComponent } from './components/offer-booking-fisiq/offer-booking-fisiq.component';
import { BookingStepsComponent } from './components/booking-steps/booking-steps.component';

import { Helper } from './helper';
import { NavigationComponent } from './components/navigation/navigation.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { ExpertComponent } from './components/expert/expert.component';
import { ServiceComponent } from './components/service/service.component';

import { MainService } from './services/main.service';
import { UsersService } from './services/users.service';
import { BookingsService } from './services/bookings.service';
import { GuardService } from './services/guard.service';

const appRoutes: Routes = [
  {pathMatch: 'full', path: '', component: LoginComponent},
  {pathMatch: 'full', path: 'login', component: LoginComponent},
  {pathMatch: 'full', path: 'signup', component: SignupComponent},
  {pathMatch: 'full', path: 'find-clinic', component: MapComponent},
  {pathMatch: 'full', path: 'body-parts', component: BodyPartsComponent},
  {pathMatch: 'full', path: 'booking-visit', component: BookVisitComponent},
  {pathMatch: 'full', path: 'privacy-policy', component: PrivacyPolicyComponent},
  {pathMatch: 'full', path: 'booking-success/:id', component: BookingSuccessComponent, canActivate: [GuardService]},
  {pathMatch: 'full', path: 'profile', component: ProfileComponent, canActivate: [GuardService]},
  {pathMatch: 'full', path: 'bookings', component: BookingsComponent, canActivate: [GuardService]},
  {pathMatch: 'full', path: 'test', component: BookingsComponent, canActivate: [GuardService]},
  {pathMatch: 'full', path: 'offer-fysiq', component: OfferBookingFisiqComponent, canActivate: [GuardService]},
  {pathMatch: 'full', path: 'forgot-password', component: ForgotPasswordComponent},
  {pathMatch: 'full', path: 'reset-password', component: ResetPasswordComponent},
  {pathMatch: 'full', path: 'welcome', component: WelcomeComponent, canActivate: [GuardService]},
  {pathMatch: 'full', path: 'expert', component: ExpertComponent, canActivate: [GuardService]},
  {pathMatch: 'full', path: 'service', component: ServiceComponent, canActivate: [GuardService]}
];

@NgModule({
  declarations: [
    AppComponent,
    MapComponent,
    HeaderComponent,
    FooterComponent,
    BodyPartsComponent,
    BookVisitComponent,
    BookingSuccessComponent,
    LoginComponent,
    ProfileComponent,
    BookingsComponent,
    SignupComponent,
    customValidatorDirective,
    PrivacyPolicyComponent,
    InfoMessagesComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    OfferBookingFisiqComponent,
    BookingStepsComponent,
    NavigationComponent,
    WelcomeComponent,
    ExpertComponent,
    ServiceComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    SuiModule,
    MyDatePickerModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes)
  ],
  providers: [
    GuardService,
    Helper,
    MainService,
    UsersService,
    BookingsService,
    LoginComponent
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts